module.exports = __webpack_public_path__ + "media/images/talent/case6-icon02-f177c77bb263a6dc7e25faf0f555c83c.png";